import { FEATURE_BAR } from "../../data/siteData";
import "./FeatureBar.css";

const ICONS = {
  heart: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 21s-7.5-4.6-10-9.1C.5 8.4 2.3 5 5.8 5c2 0 3.4 1 4.4 2.4C11.3 6 12.7 5 14.7 5c3.5 0 5.3 3.4 3.8 6.9C19.5 16.4 12 21 12 21Z" />
    </svg>
  ),
  flask: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M9 3h6M10 3v6l-5.5 9.5A1.5 1.5 0 0 0 5.8 21h12.4a1.5 1.5 0 0 0 1.3-2.5L14 9V3" />
    </svg>
  ),
  star: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l2.9 6.6 7.1.6-5.4 4.7 1.7 7-6.3-3.9L5.7 21l1.7-7L2 9.2l7.1-.6L12 2Z" />
    </svg>
  ),
  flag: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M5 21V4m0 1h13l-2.5 4L18 13H5" />
    </svg>
  ),
};

function FeatureBar() {
  return (
    <div className="feature-bar">
      <div className="container feature-bar__inner">
        {FEATURE_BAR.map((f) => (
          <div className="feature-bar__item" key={f.label}>
            <span className="feature-bar__icon">{ICONS[f.icon]}</span>
            <span>{f.label.toUpperCase()}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FeatureBar;